import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { AdminQueryKeys, getBillingMetrics, type BillingMetricsResponse } from '../api';

export function useBillingMetrics(): UseQueryResult<BillingMetricsResponse> {
  return useQuery({
    queryKey: AdminQueryKeys.billing(),
    queryFn: ({ signal }) => getBillingMetrics(signal),
    staleTime: 60_000,
  });
}
